import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M21.5456 5.11122C22.1314 5.69701 22.1314 6.64675 21.5456 7.23254L10.3026 18.4755C9.67779 19.1003 8.66473 19.1003 8.03989 18.4755L2.45375 12.8893C1.86796 12.3036 1.86796 11.3538 2.45375 10.768C3.03953 10.1822 3.98928 10.1822 4.57507 10.768L9.17126 15.3642L19.4243 5.11122C20.0101 4.52543 20.9599 4.52543 21.5456 5.11122Z",
		fill: "currentColor"
	})
});
export default SvgCheckFill;
